<template>
    <div class="login">
        <div class="login_form">
            <div class="item_form">
                <div class="form_title">昵称</div>
                <div class="form_filed">
                    <van-field v-model="nickname" placeholder="请输入昵称" :border="false" type="tel" />
                </div>
            </div>
            <van-button block :loading="btnLoading" :disabled="submitLoading" class="login_action" @click="login">修改昵称</van-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: 'login',
    data() {
        return {
            nickname: '',
            token: null,
			submitLoading: false, // 提交loading
			btnLoading: false, // 加载loading
			publicPath: process.env.BASE_URL,
        };
    },
    created: function () {
		//根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        // 
        login() {
            var params = {
                token: this.token,
                nickname: this.nickname
            }
            this.$api.my.nickname(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    this.$toast('修改成功')
                    this.$router.back()
                } else {
                    this.$toast(res.message)
                }
            })
		},
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>
